export enum SalesChannelEnum {
    TrocasAreaCliente = 100,
}

export enum ProfileVersionEnum {
    OldVersion = 1,
    NewVersion = 2,
}
